export function parseSRT(data) {
    let srt = data.replace(/\r+/g, '');
    srt = srt.replace(/^\s+|\s+$/g, '');
    srt = srt.replace(/<[a-zA-Z/][^>]*>/g, '');
    const captions = [];
    const caplist = srt.split('\n\n');
    for (let i = 0; i < caplist.length; i++) {
        const s = caplist[i].split(/\n/);
        if (s.length < 2)
            continue;
        if (s[0].match(/^\d+$/) && s[1].match(/\d+:\d+:\d+/)) {
            const m = s[1].match(/(\d+):(\d+):(\d+)(?:,(\d+))?\s*--?>\s*(\d+):(\d+):(\d+)(?:,(\d+))?/);
            if (!m)
                continue;
            const start = parseInt(m[1], 10) * 3600 +
                parseInt(m[2], 10) * 60 +
                parseInt(m[3], 10) +
                parseInt(m[4] || '0', 10) / 1000;
            const end = parseInt(m[5], 10) * 3600 +
                parseInt(m[6], 10) * 60 +
                parseInt(m[7], 10) +
                parseInt(m[8] || '0', 10) / 1000;
            const content = s.slice(2).join('<br>');
            captions.push({ start, end, content });
        }
    }
    return captions;
}
export function parseVTT(data) {
    let vtt = data.replace(/\r+/g, '');
    vtt = vtt.replace(/^\s+|\s+$/g, '');
    vtt = vtt.replace(/<[a-zA-Z/][^>]*>/g, '');
    const captions = [];
    const caplist = vtt.split('\n\n');
    for (let i = 0; i < caplist.length; i++) {
        const s = caplist[i].split(/\n/);
        if (s.length < 1)
            continue;
        // VTT can have optional cue identifiers; find the timing line
        let timingLineIdx = -1;
        for (let j = 0; j < s.length; j++) {
            if (s[j].match(/\d+:\d+:\d+.*-->/)) {
                timingLineIdx = j;
                break;
            }
        }
        if (timingLineIdx === -1)
            continue;
        const m = s[timingLineIdx].match(/(\d+):(\d+):(\d+)(?:\.(\d+))?\s*--?>\s*(\d+):(\d+):(\d+)(?:\.(\d+))?/);
        if (!m)
            continue;
        const start = parseInt(m[1], 10) * 3600 +
            parseInt(m[2], 10) * 60 +
            parseInt(m[3], 10) +
            parseInt(m[4] || '0', 10) / 1000;
        const end = parseInt(m[5], 10) * 3600 +
            parseInt(m[6], 10) * 60 +
            parseInt(m[7], 10) +
            parseInt(m[8] || '0', 10) / 1000;
        const content = s.slice(timingLineIdx + 1).join('<br>');
        captions.push({ start, end, content });
    }
    return captions;
}
